import * as api from "../../../api/index";

import { KeyboardArrowLeft } from "@material-ui/icons";
import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import {
  ALERT,
  COUNTER,
  REMOVE_NEW_REQUESTS,
  REMOVE_ONGOING_REQUESTS,
} from "../../../constants/actionTypes";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import { VAT } from "../../../constants/actionTypes";

import "./RequestInfo.css";

function RequestInfo({
  setShowInfo,
  request,
  requestsLength,
  newRequest,
  ongoingRequest,
}) {
  dayjs.extend(relativeTime);
  const dispatch = useDispatch();
  const history = useHistory();
  const counter = useSelector((state) => state.counter);
  const [modalType, setModalType] = useState("");
  const [sending, setSending] = useState(false);
  const [items, setItems] = useState([
    {
      item: "",
      description: "",
      quantity: 0,
      unitCost: 0,
      amount: 0,
    },
  ]);
  const subtotal = items.reduce((acc, curr) => acc + curr.amount, 0);
  const vatValue = Math.ceil((subtotal * 100 * VAT) / 10000);
  const total = subtotal + vatValue;

  const handleAdd = () => {
    setItems((items) =>
      items.concat({
        item: "",
        description: "",
        quantity: 0,
        unitCost: 0,
        amount: 0,
      })
    );
  };

  const openModal = (type) => {
    document.querySelector(".details__details").open = true;
    setModalType(type);
  };

  const closeModal = () => {
    document.querySelector(".details__details").open = false;
    setModalType("");
  };

  const handleChange = (e, i) => {
    const newItems = items.map((item, index) => {
      if (i === index) item[e.target.name] = e.target.value;
      item.amount = item.unitCost * item.quantity * 100;

      return item;
    });

    setItems(newItems);
  };

  const handleIssueInvoice = async () => {
    if (subtotal <= 0 || sending) return false;

    setSending(true);

    const invoice = {
      shipping: {
        name: request.organization || request.name,
        address: request.email,
        city: "",
        postal_code: "",
      },
      items,
      type: "others",
      subtotal,
      total,
      vatValue,
      VAT,
      paid: 0,
      invoice_nr: request.project_id,
      addson: {
        notarization: 0,
        sworn: 0,
        certified: 0,
        apostilles: 0,
      },
      langs: 1,
    };

    try {
      await api.updateProject(request._id, { invoice, status: "ongoing" });
      await api.issueInvoice({
        email: null,
        user_id: null,
        invoice,
        id: request._id,
        paid: 0,
        quote_email: request.email,
        projectName: request.name,
      });
      await api.counter({ new_requests: -1, ongoing_requests: 1 });
      dispatch({
        type: COUNTER,
        payload: {
          ...counter,
          new_requests: counter.new_requests--,
          ongoing_requests: counter.ongoing_requests++,
        },
      });
      dispatch({ type: REMOVE_NEW_REQUESTS, id: request._id });
      dispatch({
        type: ALERT,
        payload: {
          severity: "success",
          message: "Invoice sent",
          duration: 5000,
          display: true,
        },
      });
      if (requestsLength < 2) history.push("/admin/index");
      if (requestsLength > 1) setShowInfo(false);
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else {
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
      }
    }
  };

  const handleConclude = async () => {
    setSending(true);

    try {
      await api.updateProject(request._id, { status: "concluded" });
      await api.counter({ ongoing_requests: -1, concluded_requests: 1 });
      dispatch({
        type: COUNTER,
        payload: {
          ...counter,
          ongoing_requests: counter.ongoing_requests - 1,
          concluded_requests: counter.concluded_requests + 1,
        },
      });
      dispatch({ type: REMOVE_ONGOING_REQUESTS, id: request._id });
      dispatch({
        type: ALERT,
        payload: {
          severity: "success",
          message: "Project Concluded",
          duration: 5000,
          display: true,
        },
      });
      if (requestsLength < 2) history.push("/admin/index");
      if (requestsLength > 1) setShowInfo(false);
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else {
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
      }
    }
  };

  return (
    <>
      <div className="details position-fixed t-0 r-0 overflow-auto h-100 px-40 z-3">
        <h2
          className="details__head d-flex align-center font-subhead py-40 pointer"
          onClick={() => setShowInfo(false)}
        >
          <KeyboardArrowLeft style={{ fontSize: "45px" }} />
          {request.name}
        </h2>
        <div className="details__scroll">
          <div className="details__min__width mb-40">
            <h3 className="details__header py-5 px-40">Project Details</h3>
            <div className="px-40 grid c-3">
              <div>
                <span className="font-bold lh-lg">Project Name: </span>
                <span className="lh-lg pl-5">{request.name}</span>
              </div>
              <div>
                <span className="font-bold lh-lg">Project ID: </span>
                <span className="lh-lg pl-5">{request.project_id}</span>
              </div>
              <div>
                <span className="font-bold lh-lg">Service: </span>
                <span className="lh-lg pl-5 text-capitalise">
                  {request.service}
                </span>
              </div>
              <div>
                <span className="font-bold lh-lg">Status: </span>
                <span className="lh-lg pl-5 text-capitalise">
                  {request.status}
                </span>
              </div>
              <div>
                <span className="font-bold lh-lg">Project Email: </span>
                <span className="lh-lg pl-5">{request.email}</span>
              </div>
              <div>
                <span className="font-bold lh-lg">Phone No.: </span>
                <span className="lh-lg pl-5">{request.phone}</span>
              </div>
              <div>
                <span className="font-bold lh-lg">Category: </span>
                <span className="lh-lg pl-5 text-capitalise">
                  {request.category}
                </span>
              </div>
              <div>
                <span className="font-bold lh-lg">Requested On: </span>
                <span className="lh-lg pl-5">
                  {dayjs(request.createdAt).format("dddd, MMMM D YYYY")}
                </span>
              </div>
            </div>
            <div className="d-flex flex-column px-40">
              <span className="font-bold lh-lg mt-10">Details: </span>
              <span className="font-heavy">{request.details}</span>
            </div>

            {newRequest && (
              <>
                <h3 className="details__header py-5 px-40 mt-40">
                  Issue Invoice
                </h3>
                <div className="details__row__ctn details__row__head py-20">
                  <div className="grid my-20 px-40 pb-10 gap-20">
                    <span className="font-bolder font-big">Item</span>
                    <span className="font-bolder font-big">Description</span>
                    <span className="font-bolder font-big">Unit Cost</span>
                    <span className="font-bolder font-big">Quantity</span>
                    <span className="font-bolder font-big">Line Total</span>
                  </div>
                  {items.map((item, i) => (
                    <div
                      className="requestInfo__input grid align-center px-40 gap-20 mb-20"
                      key={i}
                    >
                      <input
                        type="text"
                        className="p-10 font-heavy font-big"
                        value={item.item}
                        name="item"
                        onChange={(e) => handleChange(e, i)}
                      />
                      <input
                        type="text"
                        className="p-10 font-heavy font-big"
                        value={item.description}
                        name="description"
                        onChange={(e) => handleChange(e, i)}
                      />
                      <input
                        type="number"
                        className="p-10 font-heavy font-big"
                        value={item.unitCost}
                        name="unitCost"
                        onChange={(e) => handleChange(e, i)}
                      />
                      <input
                        type="number"
                        className="p-10 font-heavy font-big"
                        value={item.quantity}
                        name="quantity"
                        onChange={(e) => handleChange(e, i)}
                      />
                      <span className="h-100 w-100 p-10 text-center font-bolder font-bigger">
                        {item.amount / 100}
                      </span>
                    </div>
                  ))}
                  <div className="text-right mt-20">
                    <button
                      className="border-0 outline-0 py-5 px-20 curved-20 mx-40 font-normal font-bold"
                      onClick={handleAdd}
                    >
                      Add Row
                    </button>
                  </div>
                </div>
              </>
            )}

            {!newRequest && (
              <>
                <h3 className="details__header py-5 px-40 mt-40">
                  Invoice Summary
                </h3>
                <div className="px-40 grid c-3">
                  <div>
                    <span className="font-bold lh-lg">Invoice No.: </span>
                    <span className="lh-lg pl-5">
                      {request.invoice.invoice_nr}
                    </span>
                  </div>
                  <div>
                    <span className="font-bold lh-lg">Address: </span>
                    <span className="lh-lg pl-5">
                      {request.invoice.shipping.address}
                    </span>
                  </div>
                  <div>
                    <span className="font-bold lh-lg">Name: </span>
                    <span className="lh-lg pl-5">
                      {request.invoice.shipping.name}
                    </span>
                  </div>
                  <div>
                    <span className="font-bold lh-lg">Subtotal: </span>
                    <span className="lh-lg pl-5">
                      {Math.ceil(request.invoice.subtotal / 100)}
                    </span>
                  </div>
                  <div>
                    <span className="font-bold lh-lg">VAT: </span>
                    <span className="lh-lg pl-5">{request.invoice.VAT}%</span>
                  </div>
                  <div>
                    <span className="font-bold lh-lg">Total: </span>
                    <span className="lh-lg pl-5">
                      {request.invoice.total / 100}
                    </span>
                  </div>
                </div>
                <h3 className="details__header py-5 px-40 mt-40">
                  Invoice Items
                </h3>
                <div className="details__row__head grid c-5 my-20 px-40 py-10">
                  <span className="font-bolder">Item</span>
                  <span className="font-bolder">Description</span>
                  <span className="font-bolder">Unit Cost</span>
                  <span className="font-bolder">Quantity</span>
                  <span className="font-bolder">Total ($)</span>
                </div>
                {request.invoice.items.map((item, index) => (
                  <div
                    className="grid align-center c-5 px-40"
                    key={item.item.concat(index)}
                  >
                    <span className="">{item.item}</span>
                    <span className="ellipsis">{item.description}</span>
                    <span className="">{item.unitCost}</span>
                    <span className="">{item.quantity}</span>
                    <span className="">{(item.amount / 100).toFixed(2)}</span>
                  </div>
                ))}
              </>
            )}

            {newRequest && (
              <button
                style={{
                  opacity: sending ? "0.6" : "",
                  background: "var(--bg-green)",
                }}
                className="d-flex align-center justify-center w-100 border-0 outline-0 p-10 my-40 font-bold font-bigger w-75 mx-auto"
                onClick={() => openModal("invoice")}
                disabled={sending}
              >
                Issue Invoice
              </button>
            )}

            {ongoingRequest && (
              <button
                style={{
                  opacity: sending ? "0.6" : "",
                  background: "var(--bg-green)",
                }}
                className="d-flex align-center justify-center w-100 border-0 outline-0 p-10 my-40 font-bold font-bigger w-75 mx-auto"
                onClick={() => openModal("conclude")}
                disabled={sending}
              >
                Concluded
              </button>
            )}
          </div>
        </div>
      </div>
      {(newRequest || ongoingRequest) && (
        <details
          style={{ backgroundColor: "red" }}
          className="details__details"
        >
          <summary className="list-none"></summary>
          <div className="d-flex align-center justify-center position-fixed t-0 r-0 w-100 h-100 z-5">
            <div className="d-flex flex-column align-center text-center p-20">
              {
                <h3 className="font-subhead">
                  {modalType === "invoice"
                    ? "Issue Invoice"
                    : "Conclude Project"}
                </h3>
              }
              {modalType === "invoice" && (
                <p className="text-center font-heavy font-big py-40">
                  You are about to issue an invoice of the total sum of{" "}
                  <strong>${total / 100}</strong>, vet properly before sending.
                </p>
              )}
              {modalType === "conclude" && (
                <p className="text-center font-heavy font-big py-40">
                  You are about to conclude project {request.name}, this means
                  the project has been executed and completed.
                </p>
              )}
              <div className="d-flex justify-between">
                <button
                  className="details__btn__cancel border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                  onClick={closeModal}
                  disabled={sending}
                >
                  Cancel
                </button>

                {modalType === "invoice" && (
                  <button
                    style={{ opacity: sending ? "0.6" : "" }}
                    className="details__btn__assign d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                    disabled={sending}
                    onClick={handleIssueInvoice}
                  >
                    Issue
                    {sending && <div className="spin-white ml-10"></div>}
                  </button>
                )}
                {modalType === "conclude" && (
                  <button
                    style={{ opacity: sending ? "0.6" : "" }}
                    className="details__btn__assign d-flex justify-center align-center border-0 outline-0 p-10 font-normal font-bold w-45 rounded"
                    disabled={sending}
                    onClick={handleConclude}
                  >
                    Conclude
                    {sending && <div className="spin-white ml-10"></div>}
                  </button>
                )}
              </div>
            </div>
          </div>
        </details>
      )}
    </>
  );
}

export default RequestInfo;
